import EventService from "../services/EventService";

export default function useEvent() {
	return EventService.getInstance();
}
